
    import './styles.scoped.css';
    export default {
  "with-motion": "awsui_with-motion_b18tp_aiswy_142",
  "resize-active": "awsui_resize-active_b18tp_aiswy_161",
  "resize-side": "awsui_resize-side_b18tp_aiswy_171",
  "resize-bottom": "awsui_resize-bottom_b18tp_aiswy_174"
};
  